import defaultSettings from '@/settings'

// const title = defaultSettings.title || 'Vue Element Admin'

export default function getPageTitle(pageTitle,system) {
  let title = defaultSettings[system+'_'+title]
  if(title === undefined || title === '' || title  === 'null'){
     title = defaultSettings.title
  }

  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
